import { render, staticRenderFns } from "./EditPasswordDialog.vue?vue&type=template&id=8b78a88e&scoped=true&"
import script from "./EditPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./EditPasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditPasswordDialog.vue?vue&type=style&index=0&id=8b78a88e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b78a88e",
  null
  
)

export default component.exports